import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link as RouterLink } from 'react-router-dom';
import { useContext } from 'react';
import UserContext from './UserContext';
import { Alert, Link } from '@mui/material';
import { isBillingAdmin } from './business/Subscription';
import { getDiffDaysFromNow } from './util/TimeUtil';
import dayjs from 'dayjs';
export default function Header() {
    var _a;
    const userContext = useContext(UserContext);
    const user = userContext === null || userContext === void 0 ? void 0 : userContext.user;
    if (!user || !isBillingAdmin(user)) {
        return _jsx(_Fragment, {});
    }
    if (((_a = user.firm) === null || _a === void 0 ? void 0 : _a.subscription.status) == 'TRIAL') {
        const diffInDays = getDiffDaysFromNow(dayjs.utc(user.firm.subscription.trialEndDate));
        let severity = 'info';
        let expiryText = `Your trial is expiring in ${diffInDays + 1} days.`;
        let expired = false;
        if (diffInDays == 0) {
            severity = 'error';
            expiryText = `Your trial is expiring today.`;
        }
        else if (diffInDays == 1) {
            severity = 'error';
            expiryText = `Your trial is expiring tomorrow.`;
        }
        else if (diffInDays < 4) {
            severity = 'warning';
            expiryText = `Your trial is expiring in less than ${diffInDays + 1} days.`;
        }
        else if (isNaN(diffInDays)) {
            expiryText = `Your trial is expiring.`;
        }
        else if (diffInDays < 0) {
            expiryText = `Your trial is expired.`;
            severity = 'error';
            expired = true;
        }
        return (_jsxs(Alert, { severity: severity, style: { marginBottom: '4px' }, children: [_jsx("span", { style: { marginRight: '4px' }, children: _jsx("b", { children: expiryText }) }), _jsx("span", { children: expired
                        ? 'Please provide your payment detail or upgrade your subscription.'
                        : 'Remember to provide your payment detail or upgrade your subscription to keep your access.' }), _jsx("br", {}), window.location.pathname != '/subscription' && (_jsx("span", { children: _jsx(Link, { component: RouterLink, to: "/subscription", children: "Manage your subscription" }) }))] }));
    }
}
